import {ChangeDetectionStrategy, Component, EventEmitter, Input, Output} from '@angular/core';


@Component({
    selector: 'app-host-access',
    imports: [],
    templateUrl: './host-access.component.html',
    styleUrls: ['./host-access.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class HostAccessComponent {
  @Output() onDeactivate: EventEmitter<void> = new EventEmitter<void>()
  @Output() onChangePassword: EventEmitter<void> = new EventEmitter<void>()
  @Input() isProfile: boolean = false
}
